import { render, staticRenderFns } from "./resume.vue?vue&type=template&id=6eead5db&scoped=true&lang=pug"
import script from "./resume.vue?vue&type=script&lang=ts"
export * from "./resume.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6eead5db",
  null
  
)

export default component.exports